import { render } from "./Incomes.vue?vue&type=template&id=0c10eccf&scoped=true"
import script from "./Incomes.vue?vue&type=script&lang=js"
export * from "./Incomes.vue?vue&type=script&lang=js"

import "./Incomes.vue?vue&type=style&index=0&id=0c10eccf&lang=scss&scoped=true"

import exportComponent from "/home/misha/Рабочий стол/embody-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c10eccf"]])

export default __exports__